module.exports = __webpack_public_path__ + "img/facebook-ad.cb825eb8.webp";